import classNames from 'classnames'
import moment from 'moment-timezone'

import { ButtonRoundSm } from '@apps-common/components/elements'
import { commonIcons } from '@apps-common/config/icons'
import { OrderStatus } from '@apps-common/config/orders'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { IOrderListModel } from '@apps-common/types/portal/order'
import { ROUTE_ORDER_DETAILS } from '@apps-radionet-portal/config/private-routes'

interface IProps {
  order: IOrderListModel
}

export const OrderListCardLg: React.FC<IProps> = ({ order }) => {
  const { orderId, orderNo, orderDate, company, monitoringCentre, orderedBy, courier, trackingUrl, pickUp, status } = order
  const { navigateForward } = useNavigation()
  const ArrowIcon = commonIcons.arrowAngled

  const getStatusClass = () => {
    if (status === OrderStatus.complete) {
      return { text: 'text-on-success', bg: 'bg-success' }
    }

    if (status === OrderStatus.cancelled) {
      return { text: 'text-on-error', bg: 'bg-error' }
    }

    return { text: 'text-on-info', bg: 'bg-info' }
  }

  const getStatusText = () => {
    if (status === OrderStatus.complete) {
      return 'Complete'
    }

    if (status === OrderStatus.cancelled) {
      return 'Cancelled'
    }

    return 'Pending'
  }

  const statusClasses = getStatusClass()
  const statusText = getStatusText()

  return (
    <button
      type='button'
      aria-label='View order'
      onClick={() => navigateForward({ routeUrl: ROUTE_ORDER_DETAILS.buildPath(orderId), route: ROUTE_ORDER_DETAILS })}
    >
      <div className={classNames('flex items-center justify-start gap-[10px]')}>
        <div className={classNames('w-[3px] h-[50px] rounded-[3px]', statusClasses.bg)} />
        <div className='grow p-4 rounded-2xl overflow-hidden hover:cursor-pointer hover:opacity-80 bg-surface border border-border'>
          <div className='flex items-center justify-between'>
            <div>
              <div className='flex items-center justify-start gap-[10px]'>
                <div className={classNames('w-[15px] h-[15px] rounded-[7.5px]', statusClasses.bg)} />
                <h4 className={classNames('jost-light text-[0.8em] text-text')}>{moment(orderDate).format('DD-MM-YYYY')}</h4>
              </div>
              <div className='pl-[25px]'>
                <div className='grow items-start flex justify-between'>
                  <h4 className={classNames('jost-light text-[0.9em] text-text')}>{orderNo}</h4>
                </div>
              </div>
            </div>
            <div className='flex items-center justify-between gap-[10px]'>
              <div
                className={classNames('rounded-3xl px-[1rem] py-[0.15rem] text-[0.8em] jost-medium', statusClasses.bg, statusClasses.text)}
              >
                {statusText}
              </div>
              <ButtonRoundSm type='button' className='action-brand-solid'>
                <ArrowIcon />
              </ButtonRoundSm>
            </div>
          </div>
        </div>
      </div>
    </button>
  )

  // return (
  //   <div className='flex items-center justify-start gap-[10px]'>
  //     <div className={classNames('w-[3px] h-[80%] rounded-[3px]', statusClasses.bg)} />
  //     <div className={classNames('grow p-4 rounded-2xl', bgClasses)}>
  //       <div className='flex items-center justify-between mb-[5px]'>
  //         <div className='flex items-center justify-start gap-[10px]'>
  //           <div className={classNames('w-[15px] h-[15px] rounded-[7.5px]', statusClasses.bg)} />
  //           <h4 className={classNames('jost-light text-[0.8em]', textClasses)}>{moment(orderDate).format('DD-MM-YYYY')}</h4>
  //         </div>
  //         <div className={classNames('rounded-3xl px-[1rem] py-[0.15rem] text-[0.75em]', statusClasses.bg, statusClasses.text)}>
  //           {statusText}
  //         </div>
  //       </div>
  //       <div className='flex items-center justify-start gap-[10px]'>
  //         <div className='w-[15px] h-[15px] rounded-[7.5px] bg-transparent' />
  //         <div className='grow items-start flex justify-between'>
  //           <h4 className={classNames('jost-light text-[0.9em]', textClasses)}>{orderNo}</h4>
  //           <button
  //             type='button'
  //             className={classNames(
  //               'jost-light text-[0.75em] pl-4 pr-1 py-1 rounded-2xl flex items-center justify-between gap-[10px]',
  //               bgSecondaryClasses,
  //               textSecondaryClasses
  //             )}
  //           >
  //             See details
  //             <div
  //               className={classNames(
  //                 'w-[20px] h-[20px] rounded-[15px] flex items-center justify-center',
  //                 bgTertiaryClasses,
  //                 textSecondaryClasses
  //               )}
  //             >
  //               <ArrowIcon />
  //             </div>
  //           </button>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // )
}
